import { defineComponent as t, openBlock as n, createBlock as a, unref as l, mergeProps as p, withCtx as m, createElementVNode as c } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const w = /* @__PURE__ */ t({
  name: "IconArrowDown",
  __name: "IconArrowDown",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const r = o;
    return (i, e) => (n(), a(l(s), p(r, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        c("path", { d: "M12.75 3.104a.75.75 0 0 0-1.5 0v16.189l-3.72-3.72a.75.75 0 1 0-1.06 1.06l4.646 4.647a1.25 1.25 0 0 0 1.768 0l4.646-4.646a.75.75 0 0 0-1.06-1.06l-3.72 3.719V3.103" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  w as default
};
